module.exports = __webpack_public_path__ + "static/mobile-cursor-68a7bebd56e2c31955135bebb6d5161c.mp4";